import apiClient from '@app/config/axios.config'

export type FullRiskSummaryDataType = {
  elements: string[]
  rows: Record<string, string | number>[]
  elementExposureLevels: Record<string, string[]>
  columnRanges: { field: string; max: number }[]
  elementUnits: Record<string, string>
}

export const fetchFullClientRiskSummary = async (
  hazardLayersTypes: string[],
  selectedElementDomain: string,
  showPercent: boolean,
  valueTypeToggle: 'metric' | 'replacementCost',
  regionsToggle: string,
  abortController: AbortController,
): Promise<FullRiskSummaryDataType | null> => {
  if (hazardLayersTypes.length === 0)
    return { elements: [], rows: [], elementExposureLevels: {}, columnRanges: [], elementUnits: {} }
  const url = `/asset/rsm/vulnerabilities/${hazardLayersTypes.join(',')}?selectedElementDomain=${selectedElementDomain}&showPercent=${showPercent}&valueTypeToggle=${valueTypeToggle}&regionsToggle=${regionsToggle}`

  const response = await apiClient.get<FullRiskSummaryDataType>(url, {
    signal: abortController.signal,
  })

  return response.data
}
